import React from 'react';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Gallery from 'src/presentation/components/organisms/Gallery';
import Loader from 'src/presentation/components/atoms/Loader';
import Footer from 'src/presentation/components/organisms/Footer';
import { useFooterHeight } from 'src/presentation/hooks/useFooterHeight';
import { ScrollView, View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import type { RouteProp } from '@react-navigation/native';
import { useEventStore } from 'src/domain/stores/useEventStore';
import type { RootStackParamList } from 'src/presentation/navigation/types/NavigationTypes';
import Colors from 'src/core/utils/Colors';
import type Constants from 'src/core/utils/Constants';
import { usePageFromRoute } from 'src/presentation/hooks/usePageFromRoute';

function GalleryScreen() {
	const route = useRoute<RouteProp<RootStackParamList, typeof Constants.screenGallery>>();
	const footerHeight = useFooterHeight();
	const eventStore = useEventStore();
	const { page: data } = usePageFromRoute(route?.params, { type: 'Gallery' });
	const galleryPage = data?.type === 'Gallery' ? data : null;
	const title: string = galleryPage?.name ?? '';

	return (
		<View style={{ flex: 1, backgroundColor: Colors.white }}>
			<NavBar
				backBtn={true}
				bgImage={eventStore.activeTheme.header_bg_image}
				bgcolor={eventStore.activeTheme.header_bg_color}
				color={eventStore.activeTheme.header_text_color}
				editBtn={false}
				statusBarStyle={eventStore.activeTheme.statusbar_color}
				title={title}
			/>
			{!galleryPage ? (
				<Loader />
			) : (
				<ScrollView contentContainerStyle={{ paddingBottom: footerHeight, flexGrow: 1 }}>
					<Gallery data={galleryPage} />
				</ScrollView>
			)}
			<Footer
				backgroundColor={eventStore.activeTheme.footer_bg_color}
				backgroundImage={eventStore.activeTheme.footer_bg_image}
				backgroundType={eventStore.activeTheme.footer_bg_type}
			/>
		</View>
	);
}

export default GalleryScreen;
